// src/utils/formatters.js

export const formatCurrency = (value) => {
  // Garante que estamos lidando com um número, caso contrário, usa 0.
  const number = typeof value === 'number' ? value : 0;

  // Usa a API de Internacionalização do JavaScript para formatar a moeda no padrão pt-BR.
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(number);
};